import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import WishlistButton from "@/components/WishlistButton";

export const ProductCard = ({ product, index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.7, delay: (index % 4) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link
        to={`/product/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group block"
      >
        <div className="relative overflow-hidden bg-secondary aspect-[3/4] clip-frame">
          <img
            src={product.images[0]}
            alt=""
            className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-[1.06]"
          />
          {/* wishlist */}
          <div className="absolute top-3 left-3 z-10">
            <WishlistButton slug={product.slug} />
          </div>
          {/* spotlight */}
          <div
            className="pointer-events-none absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
            style={{
              background:
                "radial-gradient(circle at 50% 35%, rgba(157,78,221,0.22) 0%, transparent 55%)",
            }}
          />
          {/* frame corner tick */}
          <span className="absolute bottom-3 right-3 w-6 h-6 border-b border-r border-foreground/40 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          <span className="absolute top-0 left-0 h-px w-0 bg-foreground group-hover:w-full transition-all duration-500" />
        </div>
      </Link>
    </motion.div>
  );
};

export default ProductCard;
